import classNames from 'classnames';

import {
  DangerButton,
  SecondaryButton,
  useTranslation,
} from '@testsigma/atoms';

import { DeleteConnectionModalHeader } from '../delete/header';

import { useDeleteConnection } from '../../hooks';

const DeleteConnectionScreen: React.FC = () => {
  const { t } = useTranslation();
  const { isDeleting, handleDelete, handleCancel } = useDeleteConnection();

  return (
    <div className={classNames('flex gap-x-6 flex-row')}>
      <DeleteConnectionModalHeader />

      <div className='flex-1'>
        <div className='flex flex-col'>
          <div className='text-unique-600 text-lg leading-7 font-semibold'>
            {t('delete_connection')}
          </div>
          <div className='text-small leading-5 text-unique-800 mt-2'>
            {t('delete_connection_confirmation')}
          </div>
          <div className='flex gap-x-3 mt-6'>
            <DangerButton isDisabled={isDeleting} onClick={handleDelete}>
              {t('common.delete')}
            </DangerButton>

            <SecondaryButton onClick={handleCancel}>
              {t('common.cancel')}
            </SecondaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DeleteConnectionScreen };
